import { ChangeEvent, useState } from 'react';
import { ControllerRenderProps, useForm } from 'react-hook-form';
import { isValidDate } from '../helpers/date';

export type FormValues = {
  last_name: string;
  first_name: string;
  middle_name: string;
  birth_day: string;
  personal_agree: boolean;
  conditions_agree: boolean;
  isPatronymicChecked: boolean;
}

export const useAppointment = () => {

  const {
		control,
		setValue,
		formState: { errors },
		getValues,
    setError,
    clearErrors,
    watch
  } = useForm<FormValues>({
    defaultValues: {
      last_name: '',
      first_name: '',
      middle_name: '',
      birth_day: '',
      personal_agree: false,
      conditions_agree: false,
      isPatronymicChecked: false,
    }
  })

  const formState = watch();

  const [ buttonText, setButtonText ] = useState<string>('Заполните поля формы');
  const [ buttonDisabled, setButtonDisabled ] = useState<boolean>(true);

  const checkBtn = () => {
    const {
      last_name,
      first_name,
      middle_name,
      birth_day,
      personal_agree,
      conditions_agree,
      isPatronymicChecked
    } = getValues();

    if (!last_name?.trim() || !first_name?.trim() || !isValidDate(birth_day)) {
      setButtonText('Заполните поля формы');
      setButtonDisabled(true);
      return
    }

    if (!isPatronymicChecked && !middle_name?.trim())  {
      setButtonText('Заполните поля формы');
      setButtonDisabled(true);
      return
    }

    if (!personal_agree||!conditions_agree) {
      setButtonText('Подтвердите условия');
      setButtonDisabled(true);
      return
    }
    
    setButtonText('Записаться');
    setButtonDisabled(false);
    return
  }

  const onPatronymicBoxChange = () => {
    const isPatronymicChecked = getValues('isPatronymicChecked')
    setValue('isPatronymicChecked', !isPatronymicChecked)
    setValue('middle_name', '');
    setTimeout(() => {
      checkBtn();
    }, 100);
  }

  const onDateChange = (
    event: ChangeEvent<HTMLInputElement>,
    field: ControllerRenderProps<FormValues, 'birth_day'>
  ) => {
    const val = event.target.value
    field.onChange(val);

    if ((event.target as any).inputmask.isComplete()) {
      if (!isValidDate(val)) {
        return setError('birth_day', {message: `Проверьте дату - должна быть в формате ДД.ММ.ГГГГ и не ранее чем ${new Date().getFullYear() - 100} год`})
      }

      clearErrors('birth_day')
    }

    checkBtn();
  }

  return {
    errors,
    control,
    buttonText,
    buttonDisabled,
    formState,
    getValues,
    checkBtn,
    onPatronymicBoxChange,
    onDateChange,
  }
}